import { IOcupacaoEmpresaRequestDom } from "./components/pagamento/financiamento/types";
import { ITermoAceite, TTermosAceite } from "./providers/cadastros/TermosAceiteProvider/types";

export interface Regiao {
    id: number;
    nome: string;
    grupo: GruposRegiao | string;
    estados?: EstadoRegiao[] | null;
    created_at?: string | null | undefined;
    updated_at?: string | null | undefined;
}

export interface EstadoRegiao {
    estado_id?: string;
    id?: number;
    created_at?: string | null | undefined;
    updated_at?: string | null | undefined;
}

export interface Estado {
    id: string;
    nome: string;
    ibge: number;
}

export enum GruposRegiao {
    REGIAO = "Região",
    ESTADOS = "Estado",
    OUTROS = "Outros",
}

export type SiglasEstados = null | "AC" | "AL" | "AP" | "AM" | "BA" | "CE" | "ES" | "GO" | "MA" | "MT" | "MS" | "MG" | "PA" | "PB" | "PR" | "PE" | "PI" | "RJ" | "RN" | "RS" | "RO" | "RR" | "SC" | "SP" | "SE" | "TO" | "DF";

export interface Cidade {
    cidade_codigo: number | null
    estado_id: SiglasEstados
    id: number
    nome: string
}

export interface Paises {
    id: number
    nome: string
}


export interface Clientes {
    id?: number,
    nome?: string | null,
    documento?: string | null,
    fantasia?: string | null,
    telefone?: string | null,
    email?: string | null,
    tipo_pessoa?: 'fisica' | 'juridica' | 'estrangeiro' | null
    inscricao_estadual?: string | null,
    contato_whatsapp?: string | null,
    tipo_contribuinte?: 'contribuinte' | 'nao_contribuinte' | 'isento' | null
    usuario_id?: number | null,
    enderecos?: EnderecosClientes[] | null,
    usa_whatsapp?: boolean | null,
    cliente_sales_force?: boolean | null,
    readonly created_at?: string | null,
    readonly updated_at?: string | null ,
    readonly deleted_at?: string | null,
}

export interface EnderecosClientes {
    readonly id?: number,
    bairro?: string,
    cep?: string,
    logradouro?: string,
    numero?: string,
    telefone?: string,
    complemento?: string,
    cidade_id?: number,
    pais_id?: number,
    pais?: PaisType,
    tipo?: 'principal' | 'entrega'
    cidade?: Cidade,
    descricao?: string,
    sequencial?: number,
    ["@remove"]?: boolean,
    selecionado_pagamento?: boolean,
    nome?: string,
    origem_endereco?: TTIPO_ORIGEM_ENDERECO,
    readonly created_at?: string | Date,
    readonly updated_at?: string | Date,
    readonly deleted_at?: string | Date
}

export interface PaisType {
    readonly id?: number,
    nome?: string,
}


// Contas
export const TIPO_CONTA_DISTRIBUIDOR = 1;
export const TIPO_CONTA_DISTRIBUIDOR_ENGAJADO = 2;
export const TIPO_CONTA_REVENDA = 3;
export const TIPO_CONTA_INTEGRADOR = 4;
export const TIPO_CONTA_CLIENTE_FINAL = 5;
export const TIPO_CONTA_EV = 6;
export const TIPO_CONTA_SUPERVISOR = 8;
export const TIPO_CONTA_ASSISTENTE = 9;
export const TIPO_CONTA_COLABORADOR = 10;

export const LIST_TIPO_CONTA_DISTRIBUIDORES = [TIPO_CONTA_DISTRIBUIDOR, TIPO_CONTA_DISTRIBUIDOR_ENGAJADO];
export const LIST_TIPO_CONTA_REVENDAS = [TIPO_CONTA_REVENDA, TIPO_CONTA_INTEGRADOR];

export interface ContasClassificacao {
    id: number;
    cnpj_cpf: string;
    nome: string;
    fantasia: string;
    tipo_conta_id: number | null;
    classificacao_conta_id?: number | null;
    auto_classificar_conta: boolean;
    data_classificacao: string | null;
    data_proxima_classificacao: string | null;
}

export interface ContasVinculos {
    id: number;
    cnpj_cpf: string;
    nome: string;
    fantasia: string;
    tipo_conta_id: number | null;
    vinculos?: ContaVinculos[];
}

export type TTipoVinculo = "distribuidor" | "matriz" |
    "ev_distribuicao_ongrid" | "ev_distribuicao_offgrid" | "ev_verticais_ongrid" | "ev_verticais_offgrid" |
    "supervisor_distribuicao_ongrid" | "supervisor_distribuicao_offgrid" | "supervisor_verticais_ongrid" | "supervisor_verticais_offgrid" |
    "assistente_distribuicao_ongrid" | "assistente_distribuicao_offgrid" | "assistente_verticais_ongrid" | "assistente_verticais_offgrid";

export interface ContaVinculos {
    tipo: TTipoVinculo;
    conta_vinculo_id?: number;
    vinculo?: Conta;
    created_at?: string | Date;
    updated_at?: string | Date;
    "@remove"?: boolean;
}

export interface ContasVinculosEdit {
    id: number;
    vinculos: ContaVinculos[];
}

export interface ContasClassificacaoEdit {
    id: number;
    classificacao_conta_id: number | null;
    auto_classificar_conta: boolean;
    data_classificacao?: string | null;
}

export interface Conta {
    id?: number;
    auto_classificar_conta: boolean;
    cidade?: Cidade;
    cidade_codigo?: number;
    estado_id: string;
    nome: string;
    cidade_integracao?: string;
    classificacao_conta_id?: number;
    cnpj_cpf?: string;
    email?: string;
    fantasia?: string;
    telefone?: string;
    tipo_conta_id: number;
    user_guilted_id?: number | null;
    data_ativacao: string;
    data_classificacao?: string | null;
    data_proxima_classificacao?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
}

export interface Upload {
    id?: number;
    tipo: string;
    url: string;
    created_at?: string;
    updated_at?: string | null;
    validade?: string | null;
    ["@remove"]?: boolean;
}

export type PedidoType = {
    id: number;
    codigo_venda: string;
    potencia?: number | null;
    email_proposta?: string | null;
    cidade_id?: number | null;
    cpf_cnpj?: string | null;
    documento?: string | null;
    uf?: string | null;
    estado_id: string;
    distribuidor_id: number;
    revenda_id: number;
    supervisor_id?: number | null;
    ev_id?: number | null;
    assistente_id?: number | null;
    valor_pedido?: number;
    valor_servico?: number;
    valor_itens: number;
    valor_desconto: number;
    valor_pagamento: number;
    valor_pagamento_pedido?: number;
    data_previsao_faturamento?: string | null;
    percentual_desconto?: number | null;
    dias_previsao_faturamento?: number | null;
    data_ultimo_pagamento?: string | null;
    usuario_id: number;
    revenda_nome?: string;
    distribuidor_nome: string,

    pagamento_id?: number;
    forma_pagamento_id?: number;
    situacao?: PagamentoSituacaoType;
    etapa_pagamento?: PagamentosEtapasType;


    codigo_cupom?: string | null;

    valor_pago: number;
    valor_pago_pix: number;
    valor_pago_cartao_credito: number;
    valor_pago_boleto: number;
    valor_pago_carta: number;
    valor_pago_financiamento: number;
    valor_pendente: number;

    situacao_carta: PagamentosSituacaoCartaCartaCreditoType;
    situacao_comprovante: PagamentosSituacaoComprovanteCartaCreditoType;
    acoes?: TAcoesPagamentos,
    itens: PedidosItensType[];
    pagamentos?: ListaPagamentosPedido;
    endereco_entrega?: PedidoEnderecoType;
    entregue?: boolean;
    created_at?: string | null;
    updated_at?: string | null;
    deleted_at?: string | null;

    documentos: DocumentosPedido[];

    rastreamentos: PedidosRastreamentos[];

    data_expiracao: string | Date;
    destino?: string;
    tipo_proposta_envio?: any;
}

interface DocumentosPedido {
    url: string;
    tipo: string;
    numero?: number;
    data_emissao?: string;
}

interface PedidosRastreamentos { 
    data_rastreamento: string | Date, 
    ocorrencia: string, 
    observacao: string, 
    link_rastreio: string, 
    status_finalizador: boolean, 
}

export interface PedidoEnderecoType {
    readonly id?: number,
    cidade: number,
    cep: string,
    bairro: string,
    logradouro: string,
    numero?: string,
    complemento?: string,
    estado?: string,
    pedido_id?: number,
}

export interface TAcoes {

}

export interface TAcoesPagamentos extends TAcoes {
    carta_credito: boolean,
    comprovante_pagamento: boolean,
    boleto: boolean,
    financiamento_proposta: boolean,
    financiamento_documentos: boolean,
    pix: boolean,
}

export type PagamentoSituacaoType = 'pendente' | 'finalizado' | 'cancelado';
export type PagamentosEtapasType = 'dados_cliente' | 'formas_pagamento' | 'negociacao' | 'complemento_pagamento' | 'faturamento';
export type PagamentosSituacaoCartaCartaCreditoType = "pendente" | "preenchido" | "revisao" | "aprovado";
export type PagamentosSituacaoComprovanteCartaCreditoType = "pendente" | "preenchido" | "revisao" | "aprovado";


export type PagamentoType = {
    id: number;
    pedido_id: number;
    cliente_id?: number;
    endereco_cliente_id?: number;
    forma_pagamento_id?: number;
    situacao: PagamentoSituacaoType;
    etapa_pagamento: PagamentosEtapasType;
    valor_desconto: number;
    valor_pagamento: number;
    pedido?: PedidoType | null
    forma_pagamento: FormasPagamentosType | null
    created_at?: string | null;
    updated_at?: string | null;
    deleted_at?: string | null;
}

export type FormasPagamentosType = {
    readonly id?: number,
    nome?: string,
    readonly created_at?: string | Date,
    readonly updated_at?: string | Date,
    readonly deleted_at?: string | Date,
}

export interface PedidosItensType {
    readonly id?: number,
    pedido_id?: number,
    componente_id?: number,
    quantidade?: number,
    nome?: string,
    descricao?: string,
    modelo?: string,
    unidade_medida?: string,
    readonly created_at?: string | Date,
    readonly updated_at?: string | Date,
    readonly deleted_at?: string | Date,
}

export type TOrigemDocumentoPessoa = "proponente" | "conjuge" | "avalista" | "avalista_conjuge";

export interface DocumentosPagamentosType {
    id?: string,
    titulo?: string,
    descricao?: string,
    extensoes?: string | { text: string, value: string }[],    
    forma_pagamento_id?: number,
    checkout?: boolean,
    url?: string,
    sufixo_arquivo?: string,
    situacao?: string,    
    data_upload?: string,    

    origem?: TOrigemDocumentoPessoa,
    documento_cliente?: string,
    nome_cliente?: string,    
    id_documento?: number,

    arquivoSelecionado?: string,
    tamanhoArquivo?: string,
    formData?: FormData,
    documento?: string,
}

export type TiposPagamentoType = "boleto" | "cartao" | "financiamento" | "carta_credito" | "boleto_cartao" | "boleto_financiamento" | "cartao_financiamento" | "pix" | "pix_cartao" | "boleto_carta_credito" | "cartao_carta_credito" | "pix_financiamento"
    | "pix_carta_credito";

export type TiposPagamentoIDType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;

export type TipoPagamentoObject = {
    nome: string;
    value: TiposPagamentoType;
    id: number;
}

export interface FormasPagamento {
    [key: number]: TipoPagamentoObject;
}

export type TipoSituacaoPagamentoObject = {
    nome: string;
    value: PagamentoSituacaoType;
    id: string;
}

export interface SituacoesPagamento {
    [key: string]: TipoSituacaoPagamentoObject;
}

export type EtapaPagamentoObject = {
    nome: string;
    value: PagamentosEtapasType;
    id: string;
}

export interface EtapasPagamento {
    [key: string]: EtapaPagamentoObject;
}

export interface UserInfo {
    cnpjCpf: string;
    email: string;
    name: string;
    user: string;
    userId: number;
}

export interface ErrorValidate {
    hasError: boolean;
    hintText: string;
}

type DefaultPagamentoItemType = {
    valor: number;
    valor_original: number;
}

export type BoletoType = DefaultPagamentoItemType & {}
export type PixType = DefaultPagamentoItemType & {}
export type CartaoType = DefaultPagamentoItemType & {
    parcelas: number
    bandeira: string;
    numero: string;
    nome: string;
    mes_expiracao: number;
    valor_parcela: number;
    ano_expiracao: number;
    cvv: string;
}
export interface CartaCreditoType extends DefaultPagamentoItemType {
    banco: string;
    valor: number;
    carta: CartaCreditoCartaType[] | undefined;
}

export interface CartaCreditoCartaType {
    documento_pagamento_id: number;
    url: string;
}
export interface FinanciamentoType extends DefaultPagamentoItemType {
    financeira: number;
    simulacao: string | null;
    parcelas: number;
    valor_entrada: number;
    valor_parcela: number;
    taxa: number;
    carencia: number;
}

export interface PagamentoItens {
    boletos?: BoletoType[],
    pix?: PixType[],
    cartoes_credito?: CartaoType[],
    cartas_credito?: CartaCreditoType[],
    financiamento?: FinanciamentoType[],
}

export type ListaPagamentosPedido = {
    boletos?: ListaPagamentoPedidoBoletoType[];
    pix?: any[];
    cartoes_credito?: any[];
    cartas_credito?: any[];
    financiamentos?: any[];
}

export type ListaPagamentoPedidoBoletoType = {
    valor_original: number;
    situacao: string;
    data_pagamento?: string | null;
    data_vencimento?: string | null;
    url_download: string;
    codigo_barras: string;
    observacao?: string;
}


export interface PedidoPagamento {
    pedido: number;
    forma_pagamento_complemento?: number;
    forma_pagamento: number;
    itens: PagamentoItens;
}

export interface PagamentoResponseType {
    valor: number;
    situacao: string;
    message?: string[]
}


export type ListaPagamentosResponse = {
    boletos?: PagamentoResponseType[];
    pix?: PagamentoResponseType[];
    cartoes_credito?: PagamentoResponseType[];
    cartas_credito?: PagamentoResponseType[];
    financiamento?: PagamentoResponseType[];
}


export type PedidoPagamentoResponse = {
    forma_pagamento: TiposPagamentoIDType;
    pagamentos: ListaPagamentosResponse;
    situacao: PagamentoSituacaoType;
    etapa_pagamento: PagamentosEtapasType;
}

export type CartaoCreditoType = {
    cvc: string;
    expiry: string;
    focus: any;
    name: string;
    number: string;
    parcela?: CartaoCreditoParcelaType | null
}

export type CartaoCreditoParcelaType = {
    label: string;
    valor: number;
    parcelas: number;
    total: number;
    juros: boolean;
}

export type PagamentoCartaoType = {
    codigo_venda?: string;
    valor_total: number;
    parcelas: number;
    valor_parcela: number;
    valor_original: number;
    is_valid: boolean;
    issuer: string;
}

export type ItemType = {
    id?: number;
    pedido_id?: number;
    componente_id?: number;
    quantidade?: number;
    created_at?: Date;
    updated_at?: null;
    nome?: string;
    modelo?: string;
    descricao?: string;
}

export type ComponenteType = {
    id: number;
    categoria_componentes_id: number;
    modelo: string;
    nome: string;
    descricao: string;
    segmento: string;
    peso: number;
    tempo_garantia: number;
    tempo_garantia_unidade: number;
    venda: string;
    considerar_calculo: boolean;
    exibir_listagem: boolean;
    comprimento: number;
    largura: number;
    altura: number;
    imagem?: string | null;
    readonly created_at?: string | Date;
    readonly updated_at?: string | Date;
    readonly deleted_at?: string | Date;
}

enum GrupoPagamento {
    avista = 1,
    entrada_parcela = 2,
    parcelado = 3,
}

export type FormaPagamentoType = {
    mesclagem: boolean,
    nome: string,
    id: number,
    quantidade: number
}

export enum GENERO_PESSOA {
    masculinho = 0,
    feminino = 1,
}

export enum ESTADO_CIVIL {
    solteiro = 0,
    casado = 1,
    divorciado = 2,
    viuvo = 3,
}

export enum REGIME_BENS {
    comunhaoUniversalBens = 0,
    comunhaoParcialBens = 1,
    participacaoFinalAquestos = 2,
    separacaoConvencionalBens = 3,
    separacaoObrigatoriaBens = 4,
}

export enum NACIONALIDADE {
    BRASILEIRO = "brasileiro",
    ESTRANGEIRO = "estrangeiro",
    NATURALIZADO = "naturalidade"
}

export type TNacionalidade = NACIONALIDADE | null

export enum PROPRIEDADE_RESIDENCIA {
    alugado = 0,
    proprioQuitado = 1,
    proprioFinanciado = 2,
    familiar = 3,
    cedido = 4
}

export enum NATUREZA_OCUPACAO {
    assalariado = 0,
    empresario = 1,
    autonomo = 2,
    servidorPublico = 3,
    aposentado = 4,
}

export type PropostaOcupacao = {
    natureza?: number | null; // Tabela de-para
    categoria?: string | null; // Tabela de-para
    profissao?: number | null; // Consulta no WSO2
    descricao_profissao?: number | null; // Consulta no WSO2
    tempo_operacao?: string | null;
    telefone_comercial?: string | null;
    empresa?: null | IOcupacaoEmpresaRequestDom
}

export type PessoaFisica = {
    genero?: number | null; // Tabela de-para
    data_nascimento?: string | null;
    nacionalidade?: TNacionalidade | null;
    nacionalidade_pais?: TNacionalidade | null;
    naturalidade?: number | null;
    naturalidade_cidade?: string | null;
    naturalidade_uf?: string | null;
    rg?: string | null;
    data_expedicao_rg?: string | null;
    orgao_expedidor_rg?: string | null;
    uf_expedidor_rg?: string | null;
    estado_civil?: number | null; // Tabela de-para
    nome_mae?: string | null;
    regime_bens?: number | null; // Tabela de-para
    valor_patrimonio?: string | null;
    ocupacao?: PropostaOcupacao | null;
    renda_mensal?: string | null;
}

export type Pessoa = PessoaFisica & {
    documento?: string | null; //CPF-CNPJ
    nome?: string | null;
    email?: string | null;
    telefone?: string | null; //00_00000_0000 (Todos juntos)
}

export type Endereco = {
    cep?: string | null; // Fixo em 8 digitos, usar busca CEP do FW
    cidade?: Cidade | null; // Em relação ao CEP
    cidade_nome?: string | null; // Em relação ao CEP
    uf?: string | null; // Em relação ao CEP
    bairro?: string | null;
    logradouro?: string | null;
    numero?: string | null;
    complemento?: string | null;
}

export type EnderecoResidencial = Endereco & {
    situacao_imovel?: number | null;
    mesmo_instalacao?: boolean | null;
}

// Dados para gravação
export type PropostaPessoaFisica = PessoaFisica & {
    nome?: string | null,
    cpf?: string | null,
    endereco?: Endereco | null;
    endereco_residencial?: EnderecoResidencial | null;
    referencias?: PessoaReferencia[] | null;
}

export type PropostaConjuge = Pessoa & {
    endereco?: Endereco | null;
}

export type PropostaFiador = Pessoa & {
    endereco?: Endereco | null;
    conjuge?: PropostaConjuge | null;
}

export type PropostaPessoaJuridica = {

}

export interface FinanciamentoProposta {
    id?: number | null,
    pedido_id?: number | null,
    pagamento_id?: number | null,
    financiamento_proposta_id?: number | null,
    financiamento_id?: number | null,
    numero?: string | null,
    protocolo?: string | null,
    mensagem?: string | null,
    situacao?: string | null,
    situacao_proposta?: string | null,
    situacao_documentos?: string | null,
    situacao_assinatura?: string | null,
    situacao_proposta_plano?: string | null,
    data_validade?: string | null | null,
    dados_pessoa_fisica?: PropostaPessoaFisica | null,
    dados_pessoa_juridica?: PropostaPessoaJuridica | null,
    dados_bancarios?: DadosBancarios | null,
    dados_conjuge?: PropostaConjuge | null,
    dados_fiadores?: PropostaFiador[] | null,
    created_at?: string | null,
    updated_at?: string | null,
    deleted_at?: string | null,
}

export interface DadosBancarios {
    banco_id?: number | null;
    autorizar_debito_conta?: boolean | null;
    agencia?: string | null;
    digito_agencia?: string | null;
    conta?: string | null;
    digito_conta?: string | null;
}

export interface PessoaReferencia {
    nome?: string | null;
    telefone?: string | null;
}

export type JobsType = {
    id?: number;
    nome?: string;
    expressao?: string;
}

export type FinanceiraType = {
    id: number,
    nome?: string;
    pessoa_fisica: boolean;
    pessoa_jurifica: boolean;
    created_at?: string | null,
    updated_at?: string | null,
}

export interface CupomDesconto {
    codigo: string,
    valor_pagamento: number,
    percentual_desconto: number,
    valor_desconto: number,
    data_expiracao: Date | string,
    revenda: string,
}

export interface CupomDescontoEfetivar {
    cupom: string,
    codigoVenda: string,
}

export interface CupomDescontoValidar {
    cupom: string | null,
    uf: string | null,
    potencia: number | null,
    codigoVenda: string | null,
}

export type Simulacao = {
    valor?: number,
    financeiras: TFinanceiraSimulacao[],
    valor_mensal_renda_faturamento?: number;
    data_nascimento_fundacao?: string;
    parcelas?: number;
    sessao?: any;

}

export type TFinanceiraSimulacao = {
    financeira_id: number;
    termos?: ITermoAceite[]
    termos_simulacao?: TTermosAceite[]
}

export interface FinanciamentoSimulacao {
    simulacao_id: string;
    financeira_id: number;
    financeira: string;
    total_liberado: number;
    mensagem: string[];
    data_expiracao?: string;
    protocolo?: string;
    parcelas: FinanciamentoParcela[];
    id?: number;
    pagamento_id?: number;
    data_nascimento_fundacao?: string | null;
    valor_mensal_renda_faturamento?: number;
    valor_financiamento?: number;
    data_validade?: string | null;
    observacao?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    deleted_at?: string | null;
    user_guilted_id?: number;
}

export interface FinanciamentoParcela {
    protocolo?: string;
    parcela: number;
    valor_parcela: number;
    valor_entrada: number;
    taxa_juros: number;
    dias_carencia_primeiro_pagamento: number;
}

export interface IParcelasDisponiveis {
    parcelas: number[];
}
export interface FinanciamentosPlanosTypes {
    readonly id?: number,
    financiamento_proposta_id: number,
    protocolo?: string,
    parcelas: number,
    carencia: number,
    taxa: number,
    valor_entrada: number,
    valor_parcela: number,
    selecionado: boolean,
    readonly created_at?: string | Date,
    readonly updated_at?: string | Date,
    readonly deleted_at?: string | Date,
    readonly user_guilted_id?: number,
}

export interface FinanciamentosUploadsType {
    readonly id?: number,
    financiamento_id?: number,
    financeira_documento_pagamento_id?: number,
    protocolo?: string,
    sequencial?: number,
    situacao?: string,
    tipo?: string,
    url?: string,
    observacao?: string,
    data_upload?: string,
    readonly created_at?: string | Date,
    readonly updated_at?: string | Date,
    readonly deleted_at?: string | Date,
    readonly user_guilted_id?: number,
}

export enum TIPO_PESSOA_DOCUMENTO {
    PROPONENTE = "proponente",
    CONJUGE = "conjuge",
    AVALISTA = "avalista",
    AVALISTA_CONJUGE = "avalista_conjuge",
}

export enum SITUACAO_FINANCIAMENTOS_UPLOADS {
    PENDENTE = "pendente",
    PREENCHIDO = "preenchido",
    ENVIADO = "enviado",
    APROVADO = "aprovado",
    REVISAO = "revisao",
    ERRO = "erro",
}

export interface FinanciamentosType {
    readonly id?: number,
    pagamento_id?: number,
    financeira_id?: number,
    valor?: number,
    valor_original?: number,
    parcelas?: number,
    carencia?: number,
    taxa?: number,
    valor_entrada?: number,
    valor_parcela?: number,
    situacao?: string,
    situacao_proposta?: string,
    situacao_proposta_plano?: string,
    situacao_documentos?: string,
    data_pagamento?: string | Date,
    observacao?: string,
    codigo_conciliacao?: string,
    financiamento_simulacao_id?: number,
}

export enum SITUACAO_PROPOSTA_PLANO {
    PENDENTE = "pendente",
    SELECIONADO = "selecionado",
    ENVIADO = "enviado",
    APROVADO = "aprovado",
    REVISAO = "revisao",
    ERRO = "erro",
}

export enum SITUACAO_FINANCIAMENTOS {
    PENDENTE = "pendente",
    PREENCHIDO = "preenchido",
    ENVIADO = "enviado",
    APROVADO = "aprovado",
    REVISAO = "revisao",
    ERRO = "erro",
}

export enum TTIPO_ORIGEM_ENDERECO {
    ENDERECO_PAGAMENTO = "pagamento",
    ENDERECO_CRM = "crm",
}

export interface PessoasUploadsDocumento {
    nome: string,
    documento: string,
    origem: TOrigemDocumentoPessoa;
}

export enum TTIPO_TERMO_ACEITE {
    PEDIDO = "pedido",
    FINANCEIRAS = "financeira",
    FATURAMENTO = "faturamento",
}


["dados_pessoais.documento_rg_rne"].find((item) => item.startsWith("dados_pessoais."))

export interface IPixResponseType {
    readonly id?: number, 
    pagamento_id: number, 
    valor: number, 
    valor_original: number, 
    situacao: "pendente" | "gerado" | "pago" | "cancelado" | "recusado" | "erro", 
    data_pagamento?: string | Date, 
    codigo_autorizacao?: string, 
    observacao?: string, 
    codigo_conciliacao?: string, 
    url_qrcode?: string, 
    url_chave?: string,
    nome?: string,
    data_expiracao?: string,
}



export type TParametro = {
    id: string,
    valor: string,
    created_at?: string | null,
    updated_at?: string | null,
}